import { render } from "./BokSuccess.vue?vue&type=template&id=3fa70b0f"
import script from "./BokSuccess.vue?vue&type=script&lang=js"
export * from "./BokSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__